import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'gate-fallback',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './fallback.component.html',
})
export class FallbackComponent {}
